// Hand-coded demo sites — add an entry here each time a new site is built.
// Slug = business name lowercased, spaces → hyphens, punctuation stripped.
// e.g. "Sons Coffee" → "sons-coffee", "Klassique Barbers" → "klassique-barbers"

import AndrBuilderLimitedAfter from "./AndrBuilderLimitedAfter";

const DEMO_SITES = {
  "andr-builder-limited": AndrBuilderLimitedAfter,
};

export default DEMO_SITES;
